import createReactComponent from '../createReactComponent';
export default createReactComponent('focus', 'IconFocus', [
  [
    'circle',
    { cx: '12', cy: '12', r: '.5', fill: 'currentColor', key: 'svg-0' },
  ],
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-1' }],
]);
